{
  "GENERAL": {
    "CLOSE": "Закрити",
    "SHOWING_RESULTS": "Показані {firstIndex}-{lastIndex} з елементів {totalCount}",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Пошук",
      "EMPTY_STATE": "Результатів не знайдено"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Потрібно щонайменше {count}"
  }
}
